import type { TenantBrandFile } from "@kovernow/types/tenant-web-config";
import knHk from "./kn-hk.json";
import knSg from "./kn-sg.json";

/**
 * Static per-tenant brand + theme files (W-0). All tenants ship in the one
 * build; which one applies is decided at runtime from /config.json. Phase 3
 * replaces these with backend-served tenant config.
 */
export const TENANT_BRAND_FILES: Record<string, TenantBrandFile> = {
  "kn-sg": knSg as TenantBrandFile,
  "kn-hk": knHk as TenantBrandFile,
};
